/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_profile__tabs__information__form__password = /** @type {(inputs: {}) => string} */ () => {
	return `Passwort`
};

const en_profile__tabs__information__form__password = /** @type {(inputs: {}) => string} */ () => {
	return `Password`
};

const es_profile__tabs__information__form__password = /** @type {(inputs: {}) => string} */ () => {
	return `Contraseña`
};

const fr_profile__tabs__information__form__password = /** @type {(inputs: {}) => string} */ () => {
	return `Mot de passe`
};

const it_profile__tabs__information__form__password = /** @type {(inputs: {}) => string} */ () => {
	return `Password`
};

const nl_profile__tabs__information__form__password = /** @type {(inputs: {}) => string} */ () => {
	return `Wachtwoord`
};

const pt_profile__tabs__information__form__password = /** @type {(inputs: {}) => string} */ () => {
	return `Palavra-passe`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile__tabs__information__form__password(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile__tabs__information__form__password", locale)
	if (locale === "de") return de_profile__tabs__information__form__password(inputs)
	if (locale === "en") return en_profile__tabs__information__form__password(inputs)
	if (locale === "es") return es_profile__tabs__information__form__password(inputs)
	if (locale === "fr") return fr_profile__tabs__information__form__password(inputs)
	if (locale === "it") return it_profile__tabs__information__form__password(inputs)
	if (locale === "nl") return nl_profile__tabs__information__form__password(inputs)
	return pt_profile__tabs__information__form__password(inputs)
};